import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Operation } from 'fast-json-patch';
import { ConfigurationService } from '../../../core/services/ConfigurationService';
import { ConfigurationState } from '../../../core/store/reducers';

import { OpusJob, OpusJobsCriteria } from '../models';

@Injectable()
export class OpusJobsService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  getOpusJobs(criteria: OpusJobsCriteria): Observable<OpusJob[]> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        console.log('OpusJobsService.getOpusJobs(): ', criteria);
        const state = criteria.state == null ? '' : criteria.state;
        const params = new HttpParams({
          fromObject: { state }
        });

        return this.http.get<OpusJob[]>(`${c.config.apiServer}api/job/schedules`, { params });
      })
    );
  }

  updateOpusJobs(changed: OpusJob[]): Observable<OpusJob[]> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.put<OpusJob[]>(`${c.config.apiServer}api/job/schedules`, changed);
      })
    );
  }
}
